export default __webpack_public_path__ + "static/media/location_blue_icon.16c172fa.svg";